/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import urls from "../../../api/urls";
import API from "../../../api";
import {
  message,
  Table,
  Input,
  List,
  Tag,
  Tooltip,
  Button,
  Dropdown,
  Steps,
} from "antd";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import {
  serialNum,
  capitalize,
  convertDate,
  capitaliseWithHyphen,
} from "../../../utils";
import { ReloadOutlined } from "@ant-design/icons";
import Heading from "../../../components/Heading";
import search_icon from "../../../assests/images/search-icon.svg";
import { ReactComponent as Pfd_icon } from "../../../assests/images/SVG/pdf-red-approval.svg";
import EllipsisWithTooltip from "../../../components/EllipsisWithToolTip";
import Highlighter from "react-highlight-words";

// import { ReactComponent as Pfd_red_icon } from "../../assests/images/SVG/pdf-red-icon.svg";
import { customerOnboardingAPI } from "../../../api/LeadApi";

import "./style.scss";
import constants from "../../../constants/constants";
import useCustomNavigate from "../../../components/customNavigationHook";
const { ROLES } = constants;
const { HO_ADMIN, HO_LEGAL, HO_FINANCE } = ROLES;
const { CREATE_LEAD } = urls;
function CustomerApprovalLeadList({ userType, tabKey, url, actionPresent }) {
  const debounceTimeout = useRef(null);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [filters, setFilters] = useState({});
  const [debouncedFilters, setDebouncedFilters] = useState({});
  const navigate = useCustomNavigate();
  let role = JSON.parse(localStorage.getItem("userinfo"));

  useEffect(() => {
    getLeadList({
      pageNum: 0,
      pageSize: 10,
      customerType: userType,
    });
  }, []);

  const statusList = [
    {
      value: "approved",
      text: "Approved",
    },
    {
      value: "pending",
      text: "Pending",
    },
    {
      value: "rejected",
      text: "Rejected",
    },
  ];

  const getLeadList = async (params) => {
    setLoading(true);

    let response;
    if (role?.roles?.includes(HO_ADMIN)) {
      response = await customerOnboardingAPI.getAllLeadList(params);
    } else {
      response = await customerOnboardingAPI.getAllLeadListWithoutPremise({
        ...params,
        status: "APPROVED",
      });
    }

    if (response?.status) {
      const res = response?.response?.data;
      setTotalPageSize(res?.count);
      setLoading(false);
      setTableData(
        res?.data?.map(
          (item) =>
            ({
              ...item,
              contactNumbers:
                item?.contactNumbers?.find((e) => e?.type === "default")
                  ?.number ||
                item?.contactNumbers?.[0]?.number ||
                "N/A",
              emails:
                item?.emails?.find((e) => e?.type === "personal")?.email ||
                item?.emails?.[0]?.email ||
                "N/A",
            } || [])
        )
      );
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };
  const reRoute = (pathName, rateCardName) => {
    navigate(pathName, {
      state: {
        tabKey: tabKey,
        reRoute: url,
        actionPresent: actionPresent,
        heading: "Lead Details",
        apiUrl: CREATE_LEAD,
      },
    });
  };

  useEffect(() => {
    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      const handler = setTimeout(() => {
        getLeadList({
          pageNum: 0,
          pageSize: 10,
          customerType: userType,
          ...debouncedFilters,
        });
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [debouncedFilters]);

  const handleTableChange = (pagination, filters) => {
    if (filters?.status) {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        customerType: userType,
        status: filters?.status[0],
      });
    } else {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        customerType: userType,
      });
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const handleSearch = (value, dataIndex) => {
    const updatedFilters = {
      ...filters,
      [dataIndex]: value?.toString(),
    };
    setFilters(updatedFilters);
    setDebouncedFilters(updatedFilters);
  };

  const getColumnSearchProps = (dataIndex, label = dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          allowClear
          placeholder={`Search ${label || dataIndex}`}
          value={selectedKeys[0] || ""}
          onChange={(e) => {
            const value = e.target.value ? [e.target.value] : [];
            setSelectedKeys(value);
            handleSearch(e.target.value, dataIndex);
          }}
        />
      </div>
    ),
    filterIcon: (filtered) => {
      return (
        <SearchOutlined
          style={{
            color: filters[dataIndex] ? "#1890ff" : undefined,
            fontSize: "16px",
          }}
        />
      );
    },

    render: (text) => {
      return filters[dataIndex] ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[filters[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        formatText(text, 25) || "N/A"
      );
    },
  });

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const columns = [
    {
      title: "SI",
      width: 60,
      dataIndex: "sl",
      fixed: "left",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: capitaliseWithHyphen(userType) + " Name",
      dataIndex: "orgName",
      key: "orgName",

      width: 180,
      ...getColumnSearchProps(
        "orgName",
        `${capitaliseWithHyphen(userType)} Name`
      ),
      render: (text, record) => {
        return (
          <a
            onClick={() =>
              // reRoute(
              //   `/lead-details/${record.status}/${record?.customerId}`,
              //   record?.quotations
              // )
              reRoute(`/customer-details/${record?.customerId}`)
            }
          >
            {text}
          </a>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
      key: "createdByName",
      width: 150,
      render: (text) => text || "N/A",
      ...getColumnSearchProps("createdByName", "CreatedBy"),
      //   render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },

    {
      title: "Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: 100,
      //...getColumnSearchProps("fromDate", "Date"),
      render: (_, record) => (
        <div>{record?.createdDate?.split(" ")?.[0] || "---"}</div>
      ),
      //
    },
    {
      title: "Phone number",
      dataIndex: "contactNumbers",
      key: "contactNumbers",
      width: 100,
      render: (text) => text || "N/A",
      ...getColumnSearchProps("contactNumber", "Phone Number"),
    },
    {
      title: "Email",
      dataIndex: "emails",
      key: "emails",
      width: 80,
      align: "left",
      render: (text) => text || "N/A",
      ...getColumnSearchProps("email", "Email"),
    },
    {
      title: "Quote List",
      dataIndex: "quotations",
      key: "quotations",
      width: 200,
      render: (text, record) => {
        const pendingStatus = text.find(
          (e) => e.status?.toLowerCase() === "pending"
        );
        const rejectedStatus = text.find(
          (e) => e.status?.toLowerCase() === "rejected"
        );
        const statusToShow =
          pendingStatus?.status || rejectedStatus?.status || text[0]?.status;

        return text?.length > 0 ? (
          <div className="align-center">
            <a
              onClick={() => {
                //localStorage.setItem("customerId", record?.customerId);
                const id =
                  {
                    CLIENT: "2",
                    COMPANY: "3",
                  }[userType] || "1";
                navigate(`/cp-quotation-list/${record?.customerId}`, {
                  state: { tab: id, navigateUrl: "/all-approvals" },
                });
              }}
              style={{ fontSize: 12 }}
            >
              View History
            </a>
            <div
              className={`status ml-1 center ${statusToShow?.toLowerCase()}`}
              //style={{ maxWidth: "30%" }}
            >
              {capitalize(statusToShow)}
            </div>
          </div>
        ) : (
          <span style={{ color: "gray" }}>No Quote</span>
        );
      },
    },

    {
      title: "Reject Reason",
      dataIndex: "remark",
      key: "remark",

      width: 250,
      render: (text) => (text ? <EllipsisWithTooltip text={text} /> : "N/A"),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      className: "actions-col",
      filters: statusList,
      width: 100,
      filterMultiple: false,
      // render: (_, record) => (
      //   <div className={`status center ${record?.status?.toLowerCase()}`}>
      //     {capitalize(record?.status)}
      //   </div>
      // ),
      render: (text, record) => {
        let approvalStatus = "process";
        let currentStep = 1;
        if (userType === "CP") {
          const approval = record?.approval;
          const getStepStatus = () => {
            if (approval.some((item) => item.status === "REJECTED")) {
              return "error";
            }
            if (approval.every((item) => item.status === "APPROVED")) {
              return "success";
            }
            return "process";
          };
          approvalStatus = getStepStatus();
          const getCurrentStep = (record) => {
            const index = record.findIndex(
              (item) => item.status !== "APPROVED"
            );
            return index === -1 ? record.length : index;
          };
          currentStep = getCurrentStep(approval);
        }
        return userType === "CP" ? (
          <div
            className={`lead-list-status ${"CPlead_" + text?.toLowerCase()}`}
          >
            {text?.toLowerCase() === "pending"
              ? "HO Approval Pending"
              : capitalize(text) || "--"}{" "}
            <Dropdown
              overlay={
                <Steps
                  style={{ backgroundColor: "#FCF1CC", padding: 10 }}
                  direction="vertical"
                  status={approvalStatus}
                  current={currentStep}
                  items={record?.approval?.map((item) => ({
                    title: `${item.approvalStage} (${capitalize(item.status)})`,
                  }))}
                />
              }
            >
              <span className="pointer">
                <EyeOutlined />
              </span>
            </Dropdown>
          </div>
        ) : (
          <div className={`status center ${record?.status?.toLowerCase()}`}>
            {capitalize(record?.status)}
          </div>
        );
      },
    },
  ];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const filterArray = (data, currValue) => {
    return data?.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue.toLowerCase())
      )
    );
  };

  return (
    <div className="master-main-container cp-approval-list table-container">
      <div className="flex-end">
        <Button
          className="cancel-btn m-05"
          style={{ minWidth: "5%" }}
          icon={<ReloadOutlined style={{ fontSize: "15px" }} />}
          onClick={() => {
            getLeadList({
              pageNum: 0,
              pageSize: 10,
              customerType: userType,
            });
          }}
        >
          {" "}
          Reload
        </Button>
      </div>
      <Table
        className="table-head-sticky"
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        columns={columns}
        defaultCurrent={1}
        onChange={handleTableChange}
        //onChange={handlePageChange}
        dataSource={tableData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalPageSize,
          //pageSizeOptions: ["10", "20", "50", "100"],
          //showSizeChanger: true,
          itemRender: itemRender,
        }}
      />
    </div>
  );
}

export default CustomerApprovalLeadList;
